export default {
  'sendverificationsms.sendverificationsms': 'Bestätigungscode anfordern',
  'sendverificationsms.   maintext':
    "Wenn Sie auf die Schaltfläche 'SMS senden' klicken, erhalten Sie eine Nachricht auf Ihrem registrierten Telefon, die einen Bestätigungscode enthält, mit dem Sie sich registrieren können.",
  'sendverificationsms.sendsms': 'Bitte schicken Sie mir eine Nachricht',
};
